import { action, makeObservable, observable } from 'mobx';

class RouletteWheelStore {
  isStartWheel = false;

  wheelCurrentIndex = null;

  wheelNextIndex = null;

  isStopAnim = false;

  startPosition = 0;

  constructor() {
    makeObservable(this, {
      isStopAnim: observable,
      isStartWheel: observable,
      wheelNextIndex: observable,
      wheelCurrentIndex: observable,
      startPosition: observable,
      endWheel: action.bound,
      startWheel: action.bound,
      setIsStopAnim: action.bound,
      resetBetStore: action.bound,
      setStartPosition: action.bound,
      setWheelCurrentIndex: action.bound,
    });
  }

  setIsStopAnim(bool) {
    this.isStopAnim = bool;
  }

  setStartPosition(deg) {
    this.startPosition = deg;
  }

  setWheelCurrentIndex(deg) {
    const curIndex = Math.abs(36 - Math.round(deg / 9.7));
    this.wheelCurrentIndex = curIndex;
    document.documentElement.style.setProperty('--rouletteWheelCurrentIndex', `${curIndex || 0}`);
  }

  startWheel(nextIndex) {
    this.isStartWheel = true;
    this.wheelNextIndex = nextIndex;
    document.documentElement.style.setProperty('--sectorDeg', `-9.7deg`);
    document.documentElement.style.setProperty('--rouletteWheelNextIndex', `${nextIndex || 0}`);
  }

  endWheel(nextIndex) {
    this.wheelCurrentIndex = nextIndex;
    this.isStartWheel = false;
    document.documentElement.style.setProperty('--rouletteWheelCurrentIndex', `${nextIndex || 0}`);
  }

  resetBetStore() {
    this.isStartWheel = false;
    this.isStopAnim = false;
    this.wheelCurrentIndex = null;
    // this.wheelNextIndex = null;
    this.startPosition = 0;
  }
}

export const rouletteWheelStore = new RouletteWheelStore();
